import {DEFAULT_TAX_ACCOUNTANT_NAME, TaxAccountantNameModel} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	taxAccountantName: TaxAccountantNameModel.model,
	recommendedTaxAccountantName: TaxAccountantNameModel.model
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantRecommendationModel = {schema, model};
export type ITaxAccountantRecommendationModel = z.infer<typeof TaxAccountantRecommendationModel.model>;
export const DEFAULT_TAX_ACCOUNT_RECOMMENDATION: ITaxAccountantRecommendationModel = {
	taxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME,
	recommendedTaxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME
};
